import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__position_9, ENUM_UTILS__position_9 } from '@shared/enums/ENUM__position_9';

interface PROPS {
  entity: DTO__entity_with_grid2d;
}

export function ROW1D__grid2d_name({ entity }: PROPS) {
  function get_text() {
    let out: string = entity.type;

    if (entity.type == ENUM__workspace_entity.COLLECTION_CUSTOM) {
      out = entity.name;
    }

    out = out.replace(/_/g, ' ');
    out = out.replace(/collection/g, '');

    return out;
  }

  return (
    <div
      className={`absolute px-2 py-1 text-xs text-bar-foreground bg-bar rounded-md border border-component-border ${ENUM_UTILS__position_9.to_css(ENUM__position_9.BOTTOM_RIGHT)}`}
    >
      {get_text()}
    </div>
  );
}
